import ApiService from "./ApiService";


export async function apiSendMail(data) {
    return ApiService.fetchData({
        url: '/connect/mail?twitter=true',
        method: 'post',
        data,
    })
}